// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} FormTemplate
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} facility
 * @property {string} type
 */

const state = {
  /** @type {FormTemplate[]} */
  templates: []
};

export default state;

/**
 * @param {state} state
 * @returns {FormTemplate[]}
 */
export function medicalCertificateTemplates (state) {
  return state.templates.filter(t => t.type === 'med-certificate');
}

/**
 * @param {state} state
 * @returns {FormTemplate[]}
 */
export function fitCertificateTemplates (state) {
  return state.templates.filter(t => t.type === 'fit-certificate');
}

/**
 * @param {state} state
 * @returns {FormTemplate[]}
 */
export function healthHistoryTemplates (state) {
  return state.templates.filter(t => t.type === 'health-history');
}

/**
 * @param {state} state
 * @returns {FormTemplate[]}
 */
export function waiverTemplates (state) {
  return state.templates.filter(t => t.type === 'waiver');
}

/**
 * @param {state} state
 * @returns {FormTemplate[]}
 */
export function claimsTemplates (state) {
  return state.templates.filter(t => t.type === 'claims');
}

/**
 * @param {state} state
 * @returns {FormTemplate[]}
 */
export function generalTemplates (state) {
  return state.templates.filter(t => t.type === 'general');
}
